import type { Theme } from '@ltvco/refresh-lib/theme';

// Hide the native scrollbar (content still scrolls) — shared by DeepSearch
// surfaces that grow then scroll: the chat input, the messages area, and the
// collapsible sidebar rail.
export const hideScrollbar = {
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
} as const;

// Thin grey scrollbar for the conversation (Recents) list — shared by the
// desktop rail and the mobile drawer so the scroll looks the same on both.
export const thinScrollbar = (theme: Theme) => ({
  scrollbarWidth: 'thin' as const,
  scrollbarColor: `${theme.palette.grey[500]} transparent`,
  '&::-webkit-scrollbar': {
    width: '6px',
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.grey[500],
    borderRadius: '8px',
  },
});

// ---- relocated from shared/chat ----
// Transparent scrollbar that stays out of the way until the user scrolls —
// shared by ChatBV list surfaces (chat history, monitored reports) so they
// don't show a persistent scrollbar.
export const transparentScrollbar = {
  scrollbarColor: 'transparent transparent',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
};
